import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getRecentlySourced } from "@/lib/api";

const CLIPS = ["clip-tl", "clip-br", "clip-tr", "clip-bl", "clip-tl", "clip-br"];

export default function RecentlySourced() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    getRecentlySourced()
      .then((d) => setItems(d.items || []))
      .catch(() => {});
  }, []);

  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-28 lg:py-40 px-6 lg:px-10 bg-[#0A0A0A] border-t border-[#1c1c1c]">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-baseline gap-4 mb-14">
          <span className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-[#E31E24]">
            (06) · Recently Sourced
          </span>
          <span className="flex-1 h-px bg-white/15 mt-1" />
          <span className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-white/50 hidden md:block">
            500+ Delivered
          </span>
        </div>

        <div className="grid grid-cols-12 gap-6 mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="col-span-12 lg:col-span-8 font-anton uppercase leading-[0.9] text-[10vw] md:text-[7vw] lg:text-[5.2vw]"
          >
            Real cars. <span className="font-cormorant italic font-medium text-[#E31E24]">real customers.</span>
          </motion.h2>
          <p className="col-span-12 lg:col-span-4 text-white/65 lg:pt-4 text-[15px] leading-relaxed">
            A short look at recent deliveries · from daily drivers to concours-ready classics. Every
            match starts with a conversation.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-6 lg:gap-8">
          {items.map((it, i) => {
            const spans = [
              "col-span-12 lg:col-span-7 lg:row-span-2 h-[420px] lg:h-[640px]",
              "col-span-6 lg:col-span-5 h-[220px] lg:h-[310px]",
              "col-span-6 lg:col-span-5 h-[220px] lg:h-[310px]",
              "col-span-12 lg:col-span-6 h-[300px] lg:h-[440px]",
              "col-span-6 lg:col-span-3 h-[220px] lg:h-[440px]",
              "col-span-6 lg:col-span-3 h-[220px] lg:h-[440px]",
            ];
            return (
              <motion.figure
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: i * 0.06, ease: [0.7, 0, 0.2, 1] }}
                className={`relative overflow-hidden ${spans[i] || "col-span-6 h-[300px]"} ${CLIPS[i % CLIPS.length]} group`}
                data-testid={`gallery-card-${i}`}
              >
                <img
                  src={it.image}
                  alt={it.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms] ease-[cubic-bezier(0.7,0,0.2,1)]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
                <figcaption className="absolute inset-x-0 bottom-0 p-5 lg:p-7 flex flex-col gap-1">
                  <div className="font-mono2 text-[10px] uppercase tracking-[0.28em] text-[#E31E24]">
                    Sourced
                  </div>
                  <div className="font-anton uppercase text-xl lg:text-2xl leading-tight">
                    {it.title}
                  </div>
                  <div className="text-white/60 text-xs lg:text-sm font-mono2">
                    {it.location}
                  </div>
                </figcaption>
              </motion.figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
